export const getUserIP = async () => {
    try {
      const ipResponse = await fetch('https://api.ipify.org?format=json');
      const ipData = await ipResponse.json();
      return ipData.ip; 
    } catch (error) {
      console.error('Error fetching IP address:', error);
      return null; 
    }
  };
  